import type { PageThemeDefinition } from "../types";

/** GTongits — 主色 #252328 */
export const gtTheme: PageThemeDefinition = {
  id: "gt",
  labelKey: "robot.setting.page_theme.gt",
  preview: {
    background: "#252328",
    cardBg: "#2F2D34",
    text: "#ffffff",
  },
  tokens: {
    background: "#252328",
    cardBg: "#2F2D34",
    text: "#ffffff",
    textSecondary: "#B8B4C0",
    border: "#3D3A42",
    headerBg: "#252328",
    inputBg: "#2F2D34",
    messageBg: "#2F2D34",
    senderBg: "#2F2D34",
    statusOnline: "#02BA54",
    statusEnding: "#ED645F",
    starActive: "#FFE200",
    starInactive: "#4A4850",
    shadow: "rgba(0, 0, 0, 0.5)",
    hoverBg: "#38363E",
    accent: "#F5A623",
    appearance: "dark",
    chatMessageText: "#FFFFFF",
    chatAgentBubbleBg: "#38363E",
    chatAgentBubbleBorder: "#3D3A42",
    chatUserGradientStart: "#F5A623",
    chatUserGradientEnd: "#C47A0A",
    chatUserMessageText: "#FFFFFF",
    chatInputFieldBg: "#252328",
    chatInputText: "#FFFFFF",
    chatInputPlaceholder: "#B8B4C0",
    chatMediaBg: "#252328",
    chatIconColor: "#FFFFFF",
    chatLinkColor: "#FFB800",
  },
};
